<template>
  <div class="cf-flex cf-flex--column cf-flex--align-center cf-flex--gap-16 loyalty-tab__list">
    <challenge-card
      v-for="challenge in sortedChallenges"
      :key="challenge.ledgerPublicId"
      :challenge="challenge"
    />

    <div
      v-if="!sortedChallenges.length"
      class="cf-card"
    >
      <div class="cf-card__body cf-text-center">
        <p class="cf-subtitle cf-subtitle--2">
          {{ noChallengesMessage }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  import ChallengeCard from './challenge-card/index.vue';

  export default {
    name: 'LoyaltyChallenges',

    components: {
      ChallengeCard
    },

    computed: {
      ...mapGetters('content', ['content']),
      ...mapGetters('offers', ['loyalty']),

      challenges() {
        return this.loyalty?.challengeLedgers || [];
      },

      sortedChallenges() {
        if (!this.challenges.length) return [];

        // Sort challenges by expiration date (earliest first)
        return [...this.challenges].sort((a, b) => new Date(a.challengeEndDate) - new Date(b.challengeEndDate));
      },

      noChallengesMessage() {
        return this.content?.Challenges?.metadata?.noChallenges || 'No challenges available at this time.';
      }
    }
  };
</script>


<style lang="sass" scoped>
.loyalty-tab__list
  max-height: 60vh
  overflow-y: auto

  > :deep(*)
    flex-shrink: 0
</style>
